import { IGeneralItem } from '../../interfaces/general-item';
import languageDictionary from '../../transloco/default';
import { NestedPropertyOf } from '../../transloco/types/nested-key-of.type';

export enum NotificationType {
    AssetStatusChanged = 'AssetStatusChanged',
    EdgeDeviceStatusChanged = 'EdgeDeviceStatusChanged',
    NewAsset = 'NewAsset',
    DeleteAsset = 'DeleteAsset',
    DataExportCompleted = 'DataExportCompleted',
    DataExportFailed = 'DataExportFailed',
    IOLinkError = 'IOLinkError',
    ProductionOrderPlanned = 'ProductionOrderPlanned',
    ProductionOrderStarted = 'ProductionOrderStarted',
    ProductionOrderCompleted = 'ProductionOrderCompleted',
    ProductionOrderDeleted = 'ProductionOrderDeleted',
    Unknown = 'Unknown',
}

export const notificationTypes: { [key: string]: { [key: string]: NestedPropertyOf<typeof languageDictionary> } } = {
    [NotificationType.AssetStatusChanged]: {
        title: 'assets.notifications.assetStatusChanged',
        text: 'assets.notifications.assetStatusChangedMessage',
    },
    [NotificationType.EdgeDeviceStatusChanged]: {
        title: 'devices.notifications.edgeDeviceStatusChanged',
        text: 'devices.notifications.edgeDeviceStatusChangedMessage',
    },
    [NotificationType.NewAsset]: {
        title: 'assets.notifications.newAsset',
        text: 'assets.notifications.newAssetMessage',
    },
    [NotificationType.DeleteAsset]: {
        title: 'assets.notifications.deleteAsset',
        text: 'assets.notifications.deleteAssetMessage',
    },
    [NotificationType.DataExportCompleted]: {
        title: 'notifications.dataExportCompleted',
        text: 'notifications.dataExportCompletedMessage',
    },
    [NotificationType.DataExportFailed]: {
        title: 'notifications.dataExportFailed',
        text: 'notifications.dataExportFailedMessage',
    },
    [NotificationType.IOLinkError]: {
        title: 'notifications.ioLinkError',
        text: 'notifications.ioLinkErrorMessage',
    },
    [NotificationType.ProductionOrderPlanned]: {
        title: 'notifications.productionOrderPlanned',
        text: 'notifications.productionOrderPlannedMessage',
    },
    [NotificationType.ProductionOrderStarted]: {
        title: 'notifications.productionOrderStarted',
        text: 'notifications.productionOrderStartedMessage',
    },
    [NotificationType.ProductionOrderCompleted]: {
        title: 'notifications.productionOrderCompleted',
        text: 'notifications.productionOrderCompletedMessage',
    },
    [NotificationType.ProductionOrderDeleted]: {
        title: 'notifications.productionOrderDeleted',
        text: 'notifications.productionOrderDeletedMessage',
    },
};

export const notificationSeverity: IGeneralItem[] = [
    { id: 0, name: 'notifications.informationSeverity' },
    { id: 1, name: 'notifications.warningSeverity' },
    { id: 2, name: 'notifications.errorSeverity' },
];

export const notificationType: IGeneralItem[] = [
    { id: NotificationType.AssetStatusChanged, name: 'assets.notifications.assetStatusChanged' },
    { id: NotificationType.EdgeDeviceStatusChanged, name: 'devices.notifications.edgeDeviceStatusChanged' },
    { id: NotificationType.NewAsset, name: 'assets.notifications.newAsset' },
    { id: NotificationType.DeleteAsset, name: 'assets.notifications.deleteAsset' },
    { id: NotificationType.DataExportCompleted, name: 'notifications.dataExportCompleted' },
    { id: NotificationType.DataExportFailed, name: 'notifications.dataExportFailed' },
    { id: NotificationType.IOLinkError, name: 'notifications.ioLinkError' },
    { id: NotificationType.ProductionOrderPlanned, name: 'notifications.productionOrderPlanned' },
    { id: NotificationType.ProductionOrderStarted, name: 'notifications.productionOrderStarted' },
    { id: NotificationType.ProductionOrderCompleted, name: 'notifications.productionOrderCompleted' },
    { id: NotificationType.ProductionOrderDeleted, name: 'notifications.productionOrderDeleted' },
];
